import { Provider } from 'react-redux'
import generateStore from './Redux/store'
import { SnackbarProvider } from 'notistack';
import CondicionLogin from './components/loggin/CondicionLogin';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import temaConfig from './components/temaConfig';
import {ThemeProvider } from '@mui/material/styles';
function App() {
  const store = generateStore()
  const notistackRef = React.createRef();
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key);
  }

  return (
    <Provider store={store}>
      <ThemeProvider theme={temaConfig}>
        <SnackbarProvider maxSnack={3} ref={notistackRef}
          action={(key) => (
            <IconButton aria-label="delete" onClick={onClickDismiss(key)} style={{ color: '#ffffff' }}>
              <CloseIcon />
            </IconButton>
          )}>
          <CondicionLogin />
        </SnackbarProvider>
        </ThemeProvider>
    </Provider>

  );
}
export default App;
